import React from "react";
import { Routes, Route } from "react-router-dom";

import WorkerAuthRoutes from "../components/worker-auth/routes/worker.auth.routes";
import WorkerPanelRoutes from "../components/worker-panel/routes/worker_panel.routes";
import WorkerJobsRoutes from "../components/worker-jobs/routes/worker-jobs.routes";
import WorkerAllPlansRoutes from "../components/worker-plans/routes/worker-allplans.routes";
import RequireAuth from "../components/worker-middleware/components/RequireAuth";
import WorkerChildCareFacilitiesRoutes from "../components/worker-childCare-facilities/routes/worker-childCare.routes";
import WorkerSnapshot from "../components/worker-snapshot/routes/worker-snapshot.routes";

const WorkerRoutes = () => {
    return (
        <Routes>
            {WorkerAuthRoutes()}
            <Route element={<RequireAuth />}>
                {WorkerPanelRoutes()}
            </Route>
            {WorkerJobsRoutes()}
            {WorkerAllPlansRoutes()}
            {WorkerChildCareFacilitiesRoutes()}
            {WorkerSnapshot()}
        </Routes>
    );
};

export default WorkerRoutes;